import React, { useEffect } from "react";
import "./Projects.css";
import {
  canvasArr,
  cssArr,
  domArr,
  reactArr,
  librariesArr,
} from "./ProjectsArr.js";

const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

function Projects({ setHome, setAboutMe, setContact }) {
  useEffect(() => {
    setHome(true);
    setAboutMe(false);
    setContact(false);

    return () => {
      setHome(true);
      setAboutMe(true);
      setContact(true);
    };
  }, [setHome, setAboutMe, setContact]);

  const windowHeight = window.innerHeight;

  function scrollDown() {
    window.scrollBy(0, windowHeight);
  }

  function scrollUp() {
    window.scrollTo(0, 0);
  }

  useEffect(() => {
    setTimeout(() => {
      const cssPros = document.querySelectorAll(
        isMobile ? ".pro-container-mobile" : ".pro-container"
      );
      cssPros.forEach((el) => el.setAttribute("class", "show-pro"));
    }, 3500);
    // Remove setShowArrow(true) if showArrow isn't used
  }, []);

  const projectSections = {
    css: cssArr,
    dom: domArr,
    react: reactArr,
    canvas: canvasArr,
    libraries: librariesArr,
  };

  return (
    <main>
      {Object.entries(projectSections).map(([sectionId, projects]) => (
        <section
          key={sectionId}
          id={sectionId}
          className={`${sectionId}-sec sec`}
        >
          <div className="sec-bc"></div>
          <div
            className={`${sectionId}-sec-header`}
            style={{ color: "#e8ff00" }}
          >
            {sectionId.charAt(0).toUpperCase() + sectionId.slice(1)} Projects
          </div>
          <div className={`${sectionId}-pros-container`}>
            {projects.map((pro, i) => (
              <div
                key={i}
                className={isMobile ? "pro-container-mobile" : "pro-container"}
              >
                <a
                  className="href"
                  href={pro.link}
                  target="_blank"
                  rel="noreferrer"
                  title={pro.title}
                >
                  <div className={`${sectionId}-pro-bc`}></div>
                  <div
                    className={`${sectionId}-pro-bc-cover`}
                    style={{
                      color: pro.type === "3D" ? "#03a9f4" : "#999797",
                    }}
                  >
                    {pro.name} - {pro.type}
                  </div>
                  <div className="image">
                    <img src={require(`${pro.src}`)} alt={pro.name} />
                  </div>
                </a>
              </div>
            ))}
          </div>
          <div
            className={sectionId === "libraries" ? "go-up" : "go-down"}
            onClick={sectionId === "libraries" ? scrollUp : scrollDown}
          >
            <i
              className={`fa-solid ${
                sectionId === "libraries" ? "fa-angles-up" : "fa-angles-down"
              }`}
            ></i>
          </div>
        </section>
      ))}
    </main>
  );
}

export default Projects;
